/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, qty: NonNullable<unknown> }} Lot_Items_Split_SummaryInputs */

const vi_lot_items_split_summary = /** @type {(inputs: Lot_Items_Split_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} lô · tổng ${i?.qty} kg`)
};

/**

* @param {Lot_Items_Split_SummaryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_split_summary = /** @type {((inputs: Lot_Items_Split_SummaryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Split_SummaryInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_split_summary(inputs)
});